<section>
    <div
        class="scroll-up-observer"
        appObserveElement
        (isIntersecting)="isIntersecting($event, 'header')"
        [isContinuous]="true"
        [debounceTime]="0"
        [rootMargin]="'50% 0px 0px 0px'"
    ></div>

    <div class="scroll-up-container">
        <div class="scroll-up-button"
             [class.visible]="visibilityScrollUpButton"
        >
            <app-button
                    (click)="scrollUp()"
                    theme="line"
                    size="smaller"
                    layout="icon-only"
                    icon="scroll-up">
            </app-button>
        </div>
    </div>
</section>

<app-algolia-instantsearch [config]="instantSearchConfig" #instantsearchInstance>
    <app-algolia-configure [searchParameters]="searchParameters | extend : { clickAnalytics: true }"></app-algolia-configure>

    <app-insights></app-insights>

    <app-grid [colGap]="true">
        <!------------------------------------------------------------------------
        -- Filter button mobile only
        ------------------------------------------------------------------------->
        <div class="filter-button">
            <app-button
                    (click)="toggleFilterMenu()"
                    theme="dark"
                    size="smaller"
                    layout="icon-label"
                    icon="sliders">
                {{ 'products.filters' | translate }}
            </app-button>
        </div>

        <app-cell mobile="0:12"
                  laptop="0:3"
        >
            <div class="outer-container" [class.filter-active-on-mobile]="mobileFilterMenuIsOpen">
                <div class="inner-container">
                    <!------------------------------------------------------------------------
                    -- Filters
                    ------------------------------------------------------------------------->
                    <div class="filter-container">
                        <div class="filter-heading" id="filter-heading">
                            <h3>{{ 'products.filters' | translate }}</h3>

                            <app-clear-refinements
                                    [clearRefinementsCommands$]="clearRefinementsCommands$"
                            ></app-clear-refinements>
                        </div>

                        <app-expansion-panel [allowMultiOpen]="true">
                            @for (filter of filtersOrder; track filter) {
                                @switch (filter) {

                                    @case (ProductListFilterEnum.Category) {
                                        @if (!category || category.children) {
                                            <app-expansion-item [isExpanded]="true">
                                                <h3 *expansionPanelTitle
                                                    class="subheading"
                                                >
                                                    {{ 'catalog-index.refinement-lists.category' | translate }}
                                                </h3>

                                                <ng-template expansionPanelContent>
                                                    @if (localization.currentLocale$ | async; as locale) {
                                                        <app-categories-refinement-list *appRecreateViewKey="category"
                                                                                        [localisedAttribute]="'catalog-index.refinement-lists.category' | translate"
                                                                                        [category]="category"
                                                        ></app-categories-refinement-list>
                                                    }
                                                </ng-template>
                                            </app-expansion-item>
                                        }
                                    }

                                    @case (ProductListFilterEnum.Brand) {
                                        @if (!hideBrandFilter) {
                                            <app-expansion-item [isExpanded]="true">
                                                <h3 *expansionPanelTitle
                                                    class="subheading"
                                                >
                                                    {{ 'catalog-index.refinement-lists.brands' | translate }}
                                                </h3>

                                                <ng-template expansionPanelContent>
                                                    <app-refinement-list [attribute]=AlgoliaFilter.Brand
                                                                         operator="or"
                                                                         [localisedAttribute]="'catalog-index.refinement-lists.brands' | translate">
                                                    </app-refinement-list>
                                                </ng-template>
                                            </app-expansion-item>
                                        }
                                    }

                                    @case (ProductListFilterEnum.SubBrand) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >
                                                {{ 'catalog-index.refinement-lists.sub-brand' | translate }}
                                            </h3>

                                            <ng-template expansionPanelContent>
                                                <app-refinement-list
                                                        [attribute]=AlgoliaFilter.SubBrand
                                                        operator="or"
                                                ></app-refinement-list>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.Color) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >
                                                {{ 'catalog-index.refinement-lists.color' | translate }}
                                            </h3>

                                            <ng-template expansionPanelContent>
                                                <app-refinement-list [attribute]=AlgoliaFilter.Color
                                                                     operator="or"
                                                                     [localisedAttribute]="'catalog-index.refinement-lists.color' | translate">
                                                </app-refinement-list>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.Material) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >
                                                {{ 'catalog-index.refinement-lists.material' | translate }}
                                            </h3>

                                            <ng-template expansionPanelContent>
                                                <app-refinement-list [attribute]=AlgoliaFilter.Materials
                                                                     operator="or"
                                                                     [localisedAttribute]="'catalog-index.refinement-lists.material' | translate">
                                                </app-refinement-list>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.Status) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >
                                                {{ 'catalog-index.refinement-lists.status' | translate }}
                                            </h3>

                                            <ng-template expansionPanelContent>
                                                <app-refinement-list [attribute]=AlgoliaFilter.Status
                                                                     operator="or"
                                                                     [localisedAttribute]="'catalog-index.refinement-lists.status' | translate">
                                                </app-refinement-list>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.Availability) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >
                                                {{ 'catalog-index.refinement-lists.availability' | translate }}
                                            </h3>

                                            <ng-template expansionPanelContent>
                                                <app-refinement-list [attribute]=AlgoliaFilter.Availability
                                                                     operator="or"
                                                                     [localisedAttribute]="'catalog-index.refinement-lists.availability' | translate">
                                                </app-refinement-list>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.SuggestedRetailPrice) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >
                                                {{ 'products.suggested-retail-price' | translate }}
                                            </h3>

                                            <ng-template expansionPanelContent>
                                                <app-price-range *appRecreateViewKey="debtorService.isNL | async"
                                                                 [attribute]="(debtorService.isNL | async) ? AlgoliaFilter.SuggestedRetailPriceNl : AlgoliaFilter.SuggestedRetailPriceIse">
                                                </app-price-range>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.Width) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >
                                                {{ 'catalog-index.refinement-lists.dimensions.width' | translate }}
                                            </h3>

                                            <ng-template expansionPanelContent>
                                                <app-size-range [attribute]="AlgoliaFilter.Width" filterName="width"></app-size-range>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.Height) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >
                                                {{ 'catalog-index.refinement-lists.dimensions.height' | translate }}
                                            </h3>

                                            <ng-template expansionPanelContent>
                                                <app-size-range [attribute]="AlgoliaFilter.Height" filterName="height"></app-size-range>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.Length) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >
                                                {{ 'catalog-index.refinement-lists.dimensions.length' | translate }}
                                            </h3>

                                            <ng-template expansionPanelContent>
                                                <app-size-range [attribute]="AlgoliaFilter.Length" filterName="length"></app-size-range>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.Diameter) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >
                                                {{ 'catalog-index.refinement-lists.dimensions.diameter' | translate }}
                                            </h3>

                                            <ng-template expansionPanelContent>
                                                <app-size-range [attribute]="AlgoliaFilter.Diameter" filterName="diameter"></app-size-range>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.Weight) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >
                                                {{ 'catalog-index.refinement-lists.dimensions.weight' | translate }}
                                            </h3>

                                            <ng-template expansionPanelContent>
                                                <app-size-range [attribute]="AlgoliaFilter.Weight" filterName="weight" unit="kg"></app-size-range>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.Shape) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >
                                                {{ 'catalog-index.refinement-lists.shape' | translate }}
                                            </h3>

                                            <ng-template expansionPanelContent>
                                                <app-refinement-list [attribute]="AlgoliaFilter.Shape" operator="or"></app-refinement-list>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.NumberOfIndividuals) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >
                                                {{ 'catalog-index.refinement-lists.number-of-individuals' | translate }}
                                            </h3>

                                            <ng-template expansionPanelContent>
                                                <app-refinement-list [attribute]="AlgoliaFilter.NumberOfIndividuals" operator="or"></app-refinement-list>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.SeatingComfort) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >
                                                {{ 'catalog-index.refinement-lists.seating-comfort' | translate }}
                                            </h3>

                                            <ng-template expansionPanelContent>
                                                <app-refinement-list [attribute]="AlgoliaFilter.SeatingComfort" operator="or"></app-refinement-list>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.Pattern) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >
                                                {{ 'catalog-index.refinement-lists.pattern' | translate }}
                                            </h3>

                                            <ng-template expansionPanelContent>
                                                <app-refinement-list [attribute]="AlgoliaFilter.Pattern" operator="or"></app-refinement-list>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.IsFsc) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >FSC</h3>

                                            <ng-template expansionPanelContent>
                                                <app-toggle-refinement [attribute]="AlgoliaFilter.IsFsc"
                                                                       [localisedAttribute]="'catalog-index.refinement-lists.show-fsc-products' | translate"
                                                ></app-toggle-refinement>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.IsAssemblyRequired) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >
                                                {{ 'catalog-index.refinement-lists.is-assembly-required' | translate }}
                                            </h3>

                                            <ng-template expansionPanelContent>
                                                <app-refinement-list [attribute]="AlgoliaFilter.IsAssemblyRequired"
                                                                     operator="or"
                                                                     [customLabels]="[
                                                                     { value: 'false', label: 'catalog-index.refinement-lists.no-assembly-required' | translate },
                                                                     { value: 'true', label: 'catalog-index.refinement-lists.assembly-required' | translate }
                                                                 ]"
                                                ></app-refinement-list>
                                            </ng-template>
                                        </app-expansion-item>
                                    }

                                    @case (ProductListFilterEnum.Is3DModelAvailable) {
                                        <app-expansion-item [isExpanded]="true">
                                            <h3 *expansionPanelTitle
                                                class="subheading"
                                            >3D</h3>

                                            <ng-template expansionPanelContent>
                                                <app-toggle-refinement [attribute]="AlgoliaFilter.Is3DModelAvailable"
                                                                       [localisedAttribute]="'catalog-index.refinement-lists.show-products-with-3d-view' | translate">
                                                </app-toggle-refinement>
                                            </ng-template>
                                        </app-expansion-item>
                                    }
                                }
                            }
                        </app-expansion-panel>
                    </div>
                </div>

                <div class="sticky-select">
                    <app-clear-refinements theme="line"
                                           [clearRefinementsCommands$]="clearRefinementsCommands$"
                    ></app-clear-refinements>

                    <app-algolia-stats>
                        <ng-template let-state="state">
                            <app-button theme="dark" (click)="toggleFilterMenu()">
                                {{ 'products.show-products' | translate: {'results': state.nbHits} }}
                            </app-button>
                        </ng-template>
                    </app-algolia-stats>
                </div>
            </div>
        </app-cell>

        <app-cell mobile="0:12" laptop="3:12">
            <!------------------------------------------------------------------------
            -- Product list top toolbar
            ------------------------------------------------------------------------->
            <div class="toolbar">
                <div class="toolbar-left">
                    <app-algolia-stats>
                        <ng-template let-state="state">
                            <h4 class="subheading">{{ state.nbHits }} {{ 'common.products' | translate }}</h4>
                        </ng-template>
                    </app-algolia-stats>
                </div>

                <div class="toolbar-right">
                    <app-sort-by></app-sort-by>

                    <app-button *ngIf="authService.user$ | async"
                                (click)="toggleInSelectMode()"
                                theme="line"
                                layout="icon-label"
                                icon="selection"
                    >
                        {{ 'catalog-index.select' | translate }}
                    </app-button>
                </div>
            </div>

            <!------------------------------------------------------------------------
            -- Product list results
            ------------------------------------------------------------------------->
            <app-product-overview-hits [emptyStateObject]="emptyState"
                                       (productsLoaded)="productsLoaded($event)"
            ></app-product-overview-hits>

            <!------------------------------------------------------------------------
            -- Bottom pagination
            ------------------------------------------------------------------------->
            <app-algolia-pagination-connector></app-algolia-pagination-connector>

        </app-cell>
    </app-grid>
</app-algolia-instantsearch>
